module.exports = __webpack_public_path__ + "img/Kyrgyzstan.665952c0.svg";